// Central place to define the backend API base URL.
// - Dev: default "/api" so Vite proxy can work.
// - Prod (subfolder hosting): default "api" so it resolves to /testrene2/api/...
export const API_BASE: string = (() => {
  const envBase = (import.meta as any).env?.VITE_API_BASE?.replace(/\/+$/, "");
  if (envBase) return envBase;

  // In dev we usually proxy /api
  if ((import.meta as any).env?.DEV) return "/api";

  // In production prefer a relative path (works in subfolders)
  return "api";
})();
